import React from "react";
import { withRouter } from "react-router-dom";
import OrderLoader from "./OrderLoader";

class Spinner extends React.Component {
  render() {
    const { location } = this.props;
    const isOrderHistoryOrTrackOrder =
  location?.pathname?.toLowerCase().includes("order-history") ||
  location?.pathname?.toLowerCase().includes("track-order");

    const spinnerVisibility = isOrderHistoryOrTrackOrder ? "hidden" : "visible";

    return (
<div
  className="full-width"
  style={{
    position: "fixed",
    top: "80px",
    left: 0,
    height: "calc(100vh - 80px)",
    width: "100vw",
    visibility: spinnerVisibility,
    zIndex: 9999,
    display: "flex",
    backgroundColor: isOrderHistoryOrTrackOrder
      ? "transparent"
      : "rgba(255, 255, 255, 0.29)",
    justifyContent: "center",
    alignItems: "center",
  }}
  role="status"
>
        <OrderLoader color="#ff0000" size={60} />
        <span className="sr-only">Loading...</span>
      </div>
    );
  }
}

export default withRouter(Spinner);
